<template>
    <div class="developTool">
        <div class="topButtons">
            <el-row :gutter="24" style="width:100%;">
                <el-col :span="8" v-for="(item, index) in buttonArr" :key="index">
                   <div class="buttonItem" id="buttonItem" @mouseenter="enterButton(index)" @mouseleave="leaveButton(index)" @click="clickTopButton(index)"  >
                        <span>{{item.name}}</span>
                        <ul class="ul">
                            <li class="li" v-for="(t, i) in item.lis" :key="i">{{t.name}}</li>
                        </ul>  
                    </div>
                </el-col>
            </el-row>
            <!-- <div class="buttonItem" id="buttonItem" @mouseenter="enterButton(index)" @mouseleave="leaveButton(index)" @click="clickTopButton(index)"  v-for="(item, index) in buttonArr" :key="index">
                <span>{{item.name}}</span>
                <ul class="ul">
                    <li class="li" v-for="(t, i) in item.lis" :key="i">{{t.name}}</li>
                </ul>  
            </div> -->
        </div>
      <div class="MCU">
          <div class="MCUTitle">
              <div class="titleText">MCU烧录仿真工具</div>
              <div class="blueLine"></div>
          </div>
          <div class="MCUContent">
              <div class="MCUItem" v-for="(item ,index) in MCUArr" :key="index"  >
                  <div class="MCUItem_img" > <img  :src="item.src" alt=""> </div>
                  <div class="mark"> <img src="@/assets/image/tool/special.png" alt=""> </div>
                  <div class="MCUItem_content">
                    <div class="MCUItem_left">
                       <div class="MCUItem_title">{{item.title}}</div>
                       <div class="MCUItem_detail" @click="gotoDetail(item.link)" v-show="item.detailText">{{item.detailText}}>>></div>
                    </div>
                    <div class="MCUItem_section">{{item.section}}</div>
                  </div>
              </div>
          </div>
      </div>
      <div class="composite">
        <div class="compositeTitle">USB/蓝牙/以太网开发工具</div>
        <div class="compositeContent">
            <div class="compositeLeft">
                <div class="liItem" v-for="(item,index) in compositeArr" :key="index"  @click="clickCompositeLi(index)">{{item.liTitle}}</div>
            </div>
            <div class="compositeRight">
                <img :src="compositeArr[activeLi].src" alt="">
                <div class="card">
                    <div style="width:35%;">
                        <div class="card_title">{{compositeArr[activeLi].title}}</div>
                        <div class="card_detail"  @click="gotoDetail(compositeArr[activeLi].link)" v-show="compositeArr[activeLi].detailText">{{compositeArr[activeLi].detailText}}>>></div>
                    </div>
                    <div class="card_section">{{compositeArr[activeLi].section}}</div>
                </div>
            </div>
        </div>
      </div>
      <div class="UART">
        <div class="UARTTitle">
              <div class="titleText">UART调试工具</div>
              <div class="blueLine"></div>
          </div>
          <div class="UARTContent">  
                <swiper ref="mySwiper" :options="swiperOptions" class="mySwiper">
                    <swiper-slide v-for="(item ,index) in UARTArr" :key="index">
                        <div class="UARTItem"  :key="index"  >
                            <div class="UARTItem_img" > <img  :src="item.src" alt=""> </div>
                            <div class="UARTItem_container">
                                <div class="UARTItem_left">
                                    <div class="UARTItem_title">{{item.title}}</div>
                                    <div class="UARTItem_detail" v-show="item.detailText" @click="UARTDetail(item.link)">{{item.detailText}}>>></div>
                                </div>
                                <div class="UARTItem_section">{{item.section}}</div>
                            </div>
                        </div>
                    </swiper-slide>
                    <!-- 分页 -->
                    <div class="swiper-pagination" slot="pagination"></div>
                    <!-- 前后按钮 -->
                    <div class="swiper-button-prev" slot="button-prev">
                        <img class="leftArrowImg" src="@/assets/image/tool/arrow2.png" alt="">
                    </div>
                    <div class="swiper-button-next" slot="button-next"> 
                        <img class="rightArrowImg" src="@/assets/image/tool/arrow1.png" alt="">
                    </div>
                </swiper>
          </div>
      </div>


      <div class="cooperate">
          <div class="header">
            <img src="@/assets/image/tool/bottom_header.png" alt="">
         </div>
          <div class="cooperateContent">
              <div class="leftPart">
                推荐集成开发环境(IDE)
              </div>
              <div class="rightPart">
                  <div class="logoPart">
                    <img src="@/assets/image/tool/mr_logo.png" alt="">
                    <div class="logoDetail" @click="cooperateDetail">了解详情  >>></div>
                  </div>
                  <div class="infoPart">
                    <div style="margin-top:30px;"><span class="name">MounRiver Studio</span><span class="note">（山河） 取自“天圆地方，山河相依”</span></div>
                    <div class="section">一款面向RISC-V、Arm等内核MCU的专业嵌入式项目开发、调试环境，提供烧录工具及完善的项目管理功能。</div>
                  </div>

              </div>
          </div>
      </div>
    </div>
</template>
<script>
import { getAction, postAction } from '@/request/http'//引入封装的get post方法
import 'swiper/css/swiper.css'
import { Swiper} from 'vue-awesome-swiper'

export default {
    components: {
        Swiper,
    },
    data(){
        return{
            swiperOptions: {
                slidesPerView: 3, // 定义slides的数量多少为一组
                spaceBetween: 20, // 在slide之间设置距离（单位px）
                autoplay: {
                    disableOnInteraction: false,
                    delay:3000
                },
                observer: true, // 监视容器元素的大小变化
                observeParents: true,//监视容器元素的父元素（包括祖先元素）的大小变化
                // mousewheel: true, // 开启鼠标滚轮控制Swiper切换
                pagination: { // 控制分页器
                    el: ".swiper-pagination",
                    clickable: true // 此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换
                },
                //上一页下一页按钮
                navigation: {
                    nextEl: ".swiper-button-next", //下一页
                    prevEl: ".swiper-button-prev", //上一页
                },
            },
            buttonArr:[
                {
                    name:'MCU烧录仿真工具',
                    lis:[
                        {name:'MCU程序烧录软件'},
                        {name:'脱机烧录器'},
                        {name:'调试下载器'},
                    ]
                },
                {
                    name:'USB开发工具',
                    lis:[
                        {name:'USB分析仪'},
                    ]
                },
                 {
                    name:'低功耗蓝牙(BLE)开发工具',
                    lis:[
                        {name:'低功耗蓝牙分析仪'},
                        {name:'安卓系统BLE调试工具'},
                    ]
                },
                 {
                    name:'以太网开发工具',
                    lis:[
                        {name:'以太网分析仪'},
                    ]
                },
                {
                    name:'UART调试工具',
                    lis:[
                        {name:'串口调试软件'},
                        {name:'USB转串口模块'},
                        {name:'免供电无线转换器'},
                        {name:'无线串口接收器'},
                    ]
                },
                {
                    name:'推荐集成开发环境(IDE)',
                    lis:[
                        {name:'MounRiver Studio'},
                    ]
                },

            ],
            MCUArr:[
                {
                    src:require('@/assets/image/tool/mcu1.png'),
                    title:'MCU程序烧录软件',
                    section:'WCH ISP Tools支持沁恒多系列MCU，可通过USB、串口、以太网等接口烧录，支持校验与DataFlash操作。',
                    link:'http://www.wch.cn/downloads/WCHISPTool_Setup_exe.html',
                    detailText:'资源下载'
                },
                {
                    src:require('@/assets/image/tool/mcu2.png'),
                    title:'脱机烧录器',
                    section:'MCU批量脱机生产烧录，支持机台控制信号，支持滚码功能，支持自定义信息写入。',
                    link:'',
                    detailText:'',
                },
                {
                    src:require('@/assets/image/tool/mcu3.png'),
                    title:'调试下载器',
                    section:'支持沁恒青稞RISC-V内核MCU和具有SWD接口的Arm内核MCU的在线调试和下载。',
                    link:'http://www.wch.cn/products/WCH-Link.html',
                    detailText:'了解详情',
                },
            ],
            activeLi:0,
            compositeArr:[
                {
                    liTitle:'USB开发工具 —— USB分析仪',
                    src:require('@/assets/image/tool/composite1.png'),
                    title:'USB分析仪',
                    section:'用于捕获USB总线上传输的高/全/低速数据，并实时分析显示，方便数据分析及问题排查。',
                    link:'https://www.wch.cn/products/USB_Monitor.html',
                    detailText:'了解详情',
                },
                {
                    liTitle:'低功耗蓝牙（BLE）开发工具 —— 低功耗蓝牙分析仪',
                    src:require('@/assets/image/tool/composite2.png'),
                    title:'低功耗蓝牙分析仪',
                    section:'用于监听BLE4.x协议的广播通道数据包或连接设备之间的通信，并通过PC软件对协议数据进行解析。',
                    link:'http://www.wch.cn/downloads/WCH_BLEAnalyzer_zip.html',
                    detailText:'资源下载',
                },
                {
                    liTitle:'低功耗蓝牙（BLE）开发工具 —— 安卓系统BLE调试工具',
                    src:require('@/assets/image/tool/composite3.png'),
                    title:'安卓系统BLE调试工具',
                    section:'用于安卓设备调试低功耗蓝牙设备。支持扫描连接、二维码一键接入、数据收发、日志保存等功能。',
                    link:'http://www.wch.cn/downloads/BLEAssist_ZIP.html',
                    detailText:'资源下载',
                },
                {
                    liTitle:'以太网开发工具 —— 以太网分析仪',
                    src:require('@/assets/image/tool/composite4.png'),
                    title:'以太网分析仪',
                    section:'用于实时采集10M/100M网口上的TCP/IP通信的数据，并配合上位机软件显示分析。',
                    link:'',
                    detailText:'',
                },

            ],
            // BLEArr:[
            //     {
            //         src:require('@/assets/image/tool/ble1.png'),
            //         title:'低功耗蓝牙分析仪',
            //         section:'用于监听BLE4.x协议的广播通道数据包或连接设备之间的通信，并通过PC软件对协议数据进行解析。',
            //         link:'http://www.wch.cn/downloads/WCH_BLEAnalyzer_zip.html'
            //     },
            //     {
            //         src:require('@/assets/image/tool/ble2.png'),
            //         title:'安卓系统BLE调试工具',
            //         section:'用于安卓设备调试低功耗蓝牙设备。支持扫描连接、二维码一键接入、数据收发、日志保存等功能。',
            //         link:'http://www.wch.cn/downloads/BLEAssist_ZIP.html'
            //     },
            // ],
            // etherArr:[
            //     {
            //         src:require('@/assets/image/tool/ether1.png'),
            //         title:'以太网分析仪',
            //         section:'用于实时采集10M/100M网口上的TCP/IP通信的数据，并配合上位机软件显示分析。',
            //         link:''
            //     },
            //     {
            //         src:require('@/assets/image/tool/ether3.png'),
            //         title:'Modbus-MOD',
            //         section:'Modbus RTU和TCP协议的双向互转，具有串口以太网透传和串口转HTTP Client的功能,无需编程。',
            //         link:'http://www.wch.cn/products/Modbus-MOD.html'
            //     },
            // ],
            UARTArr:[
                 {
                    src:require('@/assets/image/tool/uart1.png'),
                    title:'串口调试软件',
                    section:'Windows串口调试软件，通过CH343/CH340等USB转串口芯片实现PC与UART串口通信。',
                    link:'http://www.wch.cn/downloads/COMTransmit_ZIP.html',
                    detailText:'资源下载',
                },
                 {
                    src:require('@/assets/image/tool/uart2.png'),
                    title:'USB转串口模块',
                    section:'可实现USB转1/2/4/8路串口，支持I/O独立供电，兼容5V/3.3V/2.5V/1.8V等电平标准，支持高波特率与硬件流控，支持串口波特率自适应。',
                    link:'http://www.wch.cn/products/CH343.html',
                    detailText:'了解详情',
                },
                {
                    src:require('@/assets/image/tool/uart3.png'),
                    title:'免供电无线转换器',
                    section:'用于两个RS232设备的无线串口通信，替代传统的RS232连接线缆，无需软件开发、无需外部供电。',
                    link:'http://www.wch.cn/products/BLE232-NEP.html',
                    detailText:'了解详情',
                },
                {
                    src:require('@/assets/image/tool/uart4.png'),
                    title:'无线串口接收器',
                    section:'基于BLE/UART/USB三通芯片CH9143，提供电脑端虚拟串口驱动，兼容常规串口软件和串口调试工具，即连即用。',
                    link:'http://www.wch.cn/products/BLE-Dongle.html',
                    detailText:'了解详情',
                },
                
            ],
        }
    },
    computed: {
    },

    activated(){
    },
    mounted(){
         this.leaveButton()
         document.getElementsByClassName("liItem")[0].setAttribute('class','liItem activeLiItem')
    },
  
    methods:{
        //鼠标划入按钮
        enterButton(index){
            // console.log('划入',document.getElementsByClassName("ul")[index].style.display)
            document.getElementsByClassName("buttonItem")[index].style.backgroundColor="#ccecff";
            document.getElementsByClassName("ul")[index].style.display=''
        },
        //鼠标划出按钮
        leaveButton(index){
            // console.log('划出',document.getElementsByClassName("ul")[i].style.display)
           for(var i=0;i<this.buttonArr.length;i++){
            //    console.log('划出',document.getElementsByClassName("ul")[i].style.display)
                 document.getElementsByClassName("buttonItem")[i].style.backgroundColor="#f0f0f0";
                 document.getElementsByClassName("ul")[i].style.display='none';
            }
        },
        //点击上方的按钮组
        clickTopButton(index){
            switch(index){
                case 0:
                    window.scroll({
                      top: 700,
                      left: 0,
                      behavior: 'smooth'
                    });
                    break;
                case 1:
                    window.scroll({
                      top: 1400,
                      left: 0,
                      behavior: 'smooth'
                    });
                    this.clickCompositeLi(0)
                    break;
                case 2:
                    window.scroll({
                      top: 1400,
                      left: 0,
                      behavior: 'smooth'
                    });
                    this.clickCompositeLi(1)
                    break;
                case 3:
                    window.scroll({
                      top: 1400,
                      left: 0,
                      behavior: 'smooth'
                    });
                    this.clickCompositeLi(3)
                    break;
                case 4:
                    window.scroll({
                      top: 2100,
                      left: 0,
                      behavior: 'smooth'
                    });
                    break;
                default:
                    window.scroll({
                      top: 2800,
                      left: 0,
                      behavior: 'smooth'
                    });
            }
           
        },
        //点击MCU的了解详情
        gotoDetail(link){
            window.open(link)
        },

        //点击li切换
        clickCompositeLi(index){
            this.activeLi = index
            for(var i=0;i<this.compositeArr.length;i++){
                document.getElementsByClassName("liItem")[i].setAttribute('class','liItem')
            }
            document.getElementsByClassName("liItem")[index].setAttribute('class','liItem activeLiItem')
        },
        //点击USB分析仪的了解详情
        USBDetail(){
            window.location.href='http://www.wch.cn/products/USB_Monitor.html'
        },
        //点击BLE的了解详情
        BLEDetail(link){
            window.location.href=link
        },
        //点击以太网的了解详情
        etherDetail(link){
            window.location.href=link
        },
        //点击UART的了解详情
        UARTDetail(link){
            window.location.href=link
        },
        //点击mounRiver的了解详情
        cooperateDetail(){
            window.location.href='http://www.mounriver.com/'
        }
        


    },
}
</script>
<style scoped>
 .swiper-container {
    width: 100%;
    height: 100%;
  }
  .swiper-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .swiper-container{
    --swiper-navigation-size:0;
  }
  .mySwiper .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 0px;
  }
  .mySwiper .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
    position: relative;
    width: 80%;
    height: 50px;
    display: inline-block;
  }
  .mySwiper .leftArrowImg{
    width: 44px;
    position: absolute;
    right: 0px;
    top: -15px;
  }
  .mySwiper .swiper-button-next, .swiper-container-rtl .swiper-button-prev{
    position: relative;
    width: 15%;
    height: 50px;
    display: inline-block;
  }
  .mySwiper .rightArrowImg{
    width: 44px;
    position: absolute;
    top: -15px;
    left: 50%;
  }
  

.modellist_container {
  width: 100%;
  height: 100%;
 }

 .developTool {
     padding: 0 40px;
 }
 .developTool .topButtons{
     margin-top: 10px;
     margin-bottom: 70px;
     width: 100%;
     /* display: flex;
     justify-content: space-around;
     flex-wrap: wrap; */
 }
 .developTool .topButtons .buttonItem{
     /* width: 400px; */
     height: 60px;
     margin: 10px 40px;
     background-color: #f0f0f0;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 700;
     font-size: 18px;
     text-align: center;
     padding-top: 14px;
     box-sizing: border-box;
     border-radius: 10px;
     cursor: pointer;
     position: relative;
 }
 .developTool .topButtons .buttonItem .ul{
     position: absolute;
     left: 50%;
     top: 50%;
     width: 180px;
     border-radius: 8px;
     background-color: rgba(51,51,51,.8);
     z-index: 3;
     /* margin: 0;
     padding: 8px 5px; */
 }
 .developTool .topButtons .buttonItem .ul .li{
     color: #fff;
     font-size: 16px;
     line-height: 20px;
     text-align: left;
     margin: 8px 0px;
     /* list-style-type: none; */

 }
 .developTool .MCU{
     background: url('../../assets/image/tool/analyzer_bg2.png') no-repeat 0% 100%;
     margin-bottom: 100px;
 }
  .developTool .MCU .MCUTitle .titleText{
     font-size: 36px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 700;
     text-align: center;
 }
  .developTool .MCU .MCUTitle .blueLine{
     width: 80px;
     height: 6px;
     margin: 0 auto;
     margin-top: 20px;
     margin-bottom: 40px;
     background-color: rgb(30, 169, 251); 
 }
 .developTool .MCU .MCUContent{
     display: flex;
     justify-content: space-between;
 }
 .developTool .MCU .MCUContent .MCUItem{
     width: 30%;
     height: 470px;
     border-radius: 5px;
     border:1px solid #ccc;
     margin-bottom: 40px;
     box-shadow: 2px 2px 5px #aaaaaa;
     background-color: #fff;
     position: relative;
 }
 .developTool .MCU .MCUContent .MCUItem .MCUItem_img{
     height:302px;
 }
 .developTool .MCU .MCUContent .MCUItem .MCUItem_img img{
    width:100%; 
    height:302px;
    border-bottom: 1px solid #efefef;
 }
 .developTool .MCU .MCUContent .MCUItem .mark{
     position: absolute;
 }
 .developTool .MCU .MCUContent .MCUItem .MCUItem_content{
    display: flex;
    justify-content: space-between;
    margin: 10px;
    margin-top: 30px;
    margin-right: 15px;
    font-size: 17px;
 }
 .developTool .MCU .MCUContent .MCUItem .MCUItem_left{
    width: 43%;
    margin-top: 3%;
 }
 .developTool .MCU .MCUContent .MCUItem .MCUItem_title{
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 700;
     font-size: 19px;
 }
 .developTool .MCU .MCUContent .MCUItem .MCUItem_section{
     width: 56%;
     color: #999;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     letter-spacing: 1px;
     word-spacing:1px;
     /* word-break:break-all;        */
     word-break: break-word;
     text-indent: 41px;
     margin-left: 1%;
 }
 .developTool .MCU .MCUContent .MCUItem .MCUItem_detail{
    margin-top: 10px;
     color: #999;
     font-family: 'Noto Sans SC';
     cursor: pointer;
 }
 .developTool .composite{
     margin-top: 20px;
     background: url('../../assets/image/tool/hardware_bg.png') no-repeat;
     background-size:cover;
     position: relative;
     height: 500px;
 }
 .developTool .composite .compositeTitle{
     padding-top: 60px;
     font-size: 36px;
     color: #fff;
     text-align: center;
     margin-bottom: 60px;
     font-family: 'Noto Sans SC';
     font-weight: 700;
 }
 .developTool .composite .compositeContent{
     display: flex;
     width: 84%;
     height: 440px;
     position: absolute;
     top: 30%;
     left: 8%;
 }
 .developTool .composite .compositeLeft {
    width: 42%;
    background: #212830;
 }
 .developTool .composite .compositeLeft .liItem{
    font-size: 18px;
    height: 110px;
    line-height: 104px;
    color: #a3a3a3;
    border-bottom: 1px solid #a3a3a3;
    box-sizing: border-box;
    padding: 0 10px;
    cursor: pointer;
 }
 .developTool .composite .compositeLeft .activeLiItem{
    background:#155291;
    color: #fff;
    font-weight: 700;
 }
 .developTool .composite .compositeLeft .liItem:hover{
    background:#155291;
    color: #fff;
    font-weight: 700;
 }
 .developTool .composite .compositeLeft .liItem:last-child {
    border-bottom: none;
 }
 .developTool .composite .compositeRight{
    width: 58%;
    background: #fff;
    border: 2px solid #e1e1e1;
    border-left: none;
    border-top: none;
    border-radius: 2px;
 }
 .developTool .composite .compositeRight img{
    height:320px; 
    width:100%;
 }
 .developTool .composite .compositeRight .card{
    display: flex;
    width: 88%;
    margin: 0 auto;
    margin-top: 10px;
    justify-content: space-between;
 }
 .developTool .composite .compositeRight .card .card_title{
     font-size: 20px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 700;
 }
 .developTool .composite .compositeRight .card .card_detail{
     font-size: 18px;
     color: #999;
     font-family: 'Noto Sans SC';
     cursor: pointer;
 }
 .developTool .composite .compositeRight .card .card_section{
     width: 65%;
     font-size: 18px;
     color: #999;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     letter-spacing: 1px;
     word-spacing:1px;
     word-break: break-word;   
     text-indent: 41px;
 }
 .developTool .UART{
    margin-top: 180px;
    background: url('../../assets/image/college/banner_bg.png') no-repeat 100% 100%;
 }
 .developTool .UART .UARTTitle .titleText{
     font-size: 36px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 700;
     text-align: center;
 }
 .developTool .UART .UARTTitle .blueLine{
     width: 80px;
     height: 6px;
     margin: 0 auto;
     margin-top: 20px;
     margin-bottom: 60px;
     background-color: rgb(30, 169, 251); 
 }
 .developTool .UART .UARTContent{
     display: flex;
     justify-content: space-between;
     flex-wrap: wrap;
 }
 .developTool .UART .UARTContent .UARTItem{
     width: 500px;
     height: 470px;
     border-radius: 2px;
     border:1px solid #ccc;
     margin-bottom: 40px;
     background: #fff;
     position: relative;
 }
 .developTool .UART .UARTContent .UARTItem .UARTItem_img{
    border-bottom: 1px solid #ebebeb;
    height: 314px;
 }
 .developTool .UART .UARTContent .UARTItem .UARTItem_img img{
    width: 100%;
    height: 314px;
 }
 .developTool .UART .UARTContent .UARTItem .UARTItem_container{
    display: flex;
    justify-content: space-between;
    width: 94%;
    margin: 0 auto;
    margin-top: 20px;
    font-size: 18px;
 }
 .developTool .UART .UARTContent .UARTItem .UARTItem_title{
     margin-bottom: 10px;
     font-size: 20px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 700;
 }
 .developTool .UART .UARTContent .UARTItem .UARTItem_left{
    width: 35%;
 }
 .developTool .UART .UARTContent .UARTItem .UARTItem_section{
     width: 63%;
     color: #999;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     letter-spacing: 1px;
     word-spacing:1px;
     word-break:break-all;       
     text-indent: 41px;
 }
 .developTool .UART .UARTContent .UARTItem .UARTItem_detail{
     color: #999;
     font-family: 'Noto Sans SC';
     cursor: pointer;
     margin-top: 10px;
 }
  .cooperate{
      height: 315px;
      margin: 80px 0px;
      background: url('../../assets/image/tool/bottom_bg.png') no-repeat ;
      background-size: cover;
      position: relative;
  }
  .cooperate .header{
    position: absolute;
    top: 25px;
    left: 17%;
  }
  .cooperate .header img{
    width: 100%;
  }
  .cooperate .cooperateContent{
      display: flex;
      justify-content: space-between;
      padding-top: 95px;
      margin-left: 30%;
  }
  .cooperate .cooperateContent .leftPart{
    width: 42%;
    font-size: 36px;
    color: #333;
    font-family: Noto Sans SC;
    font-weight: 700;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .cooperate .cooperateContent .rightPart{
    width: 58%;
    display: flex;
  }
  .cooperate .cooperateContent .rightPart .logoPart img{
    width: 130px;
  }
  .cooperate .cooperateContent .rightPart .logoPart .logoDetail{
    width: 170px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    color: #fff;
    font-family: 'Noto Sans SC';
    font-weight: 400;
    background-color: rgb(30, 169, 251);
    text-align: center;
    border-radius: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    margin-left: -24px;
    margin-top: 10px;
  }
  .cooperate .cooperateContent .rightPart .infoPart {
      margin-left: 10px;
  }
  .cooperate .cooperateContent .rightPart .infoPart .name{
      font-size: 18px;
      color: #fdac06;
      font-family: 'Noto Sans SC';
      font-weight: 700;
  }
  .cooperate .cooperateContent .rightPart .infoPart .note{
      font-size: 18px;
      color: #999;
      font-family: 'Noto Sans SC';
      font-weight: 400;
  }
  .cooperate .cooperateContent .rightPart .infoPart .section{
      font-size: 18px;
      color: #333;
      font-family: 'Noto Sans SC';
      font-weight: 400;
      text-indent: 41px;
      margin-top: 30px;
  }
  


  @media screen and (min-width:1280px) and (max-width:1650px){
    
    .developTool .MCU .MCUContent .MCUItem .MCUItem_content{
        font-size: 16px;
        margin-right: 10px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_title{
        font-size: 16px;
    }
    .developTool .composite .compositeContent{
        width: 88%;
        left: 6%;
    }
    .developTool .composite .compositeLeft .liItem{
        font-size: 16px;
    }
    .developTool .composite .compositeRight .card{
        width: 96%;
    }
    .developTool .UART .UARTContent .UARTItem{
        width: 460px;
        height: 450px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_container{
        font-size: 16px;
        width: 98%;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_title{
        font-size: 18px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_left{
        width: 42%;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_section{
        width: 58%;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_img{
        height: 300px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_img img{
        height: 300px;
    }
    .cooperate .cooperateContent .leftPart{
        width: 35%;
        font-size: 28px;
    }
    .cooperate .cooperateContent .rightPart{
        width: 65%;
    }
    .cooperate .cooperateContent .rightPart .logoPart img{
        width: 100px;
    }
    .cooperate .cooperateContent .rightPart .logoPart .logoDetail{
        width: 130px;
        font-size: 16px;
        height: 34px;
        line-height: 34px;
    }
    .cooperate .cooperateContent .rightPart .infoPart .note{
        font-size: 16px;
    }
  }
  
  @media screen and (min-width:2200px) and (max-width:2559px){
    .developTool .MCU .MCUContent{
        width: 88%;
        margin: 0 auto;
    }
    .developTool .MCU .MCUContent .MCUItem{
        width: 28%;
        height: 490px;
    }
    .developTool .composite .compositeContent{
        width: 74%;
        left: 13%;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_img{
        height: 320px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_img img{
        height: 320px;
    }
  }
   @media screen and (min-width:2560px) and (max-width:3300px){
    .developTool .MCU .MCUContent{
        width: 90%;
        margin: 0 auto;
    }
    .developTool .MCU .MCUContent .MCUItem{
        width: 28%;
        height: 520px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_content{
        font-size: 18px;
        margin-right: 20px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_title{
        font-size: 22px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_img{
        height: 350px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_img img{
        height: 350px;
    }
    .developTool .composite .compositeContent{
        width: 64%;
        left: 18%;
    }
    .developTool .composite .compositeLeft{
        width: 48%;
    }
    .developTool .composite .compositeRight{
        width: 52%;
    }
    .developTool .UART .UARTContent .UARTItem{
        width: 550px;
        height: 520px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_img{
        height: 350px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_img img{
        height: 350px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_title{
        font-size: 22px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_container{
        font-size: 18px;
    }
  }
  @media screen and (min-width:2801px) and (max-width:3300px){
    .developTool .MCU .MCUContent{
        width: 88%;
        margin: 0 auto;
    }
    .developTool .MCU .MCUContent .MCUItem{
        width: 28%;
        height: 570px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_img{
        height: 420px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_img img{
        height: 420px;
    }
    .developTool .UART .UARTContent .UARTItem{
        width: 620px;
        height: 520px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_img{
        height: 350px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_img img{
        height: 350px;
    }
  }
  @media screen and (min-width:3301px) and (max-width:4000px){
    .developTool .MCU .MCUContent{
        width: 78%;
        margin: 0 auto;
    }
    .developTool .MCU .MCUContent .MCUItem{
        width: 28%;
        height: 600px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_img{
        height: 440px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_img img{
        height: 440px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_content{
        font-size: 20px;
        margin-right: 20px;
    }
    .developTool .MCU .MCUContent .MCUItem .MCUItem_title{
        font-size: 22px;
    }
    .developTool .composite .compositeContent{
        width: 56%;
        left: 22%;
    }
    .developTool .composite .compositeLeft{
        width: 50%;
    }
    .developTool .composite .compositeRight{
        width: 50%;
    }
    .developTool .UART .UARTContent .UARTItem{
        width: 720px;
        height: 600px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_img{
        height: 420px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_img img{
        height: 420px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_title{
        font-size: 22px;
    }
    .developTool .UART .UARTContent .UARTItem .UARTItem_container{
        font-size: 20px;
    }
    
  }
  
</style>